const dialplancsvcolumndata = [
  { id: "dialplan_name", title: "Name", default: true },
  { id: "dialplan_context", title: "Context", default: true },
  { id: "dialplan_description", title: "Description", default: true },
  { id: "dialplan_order", title: "Order" },
  { id: "dialplan_enabled", title: "Status", default: true },
];
export default dialplancsvcolumndata;
